import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useContext, useCallback } from 'react';
import { CloseButton } from '../CloseButton';
import ModalContext from './ModalContext';
export const ModalHeader = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { closeLabel = 'Close', closeButton = false, onHide, className, children, ...rest } = props;
    const context = useContext(ModalContext);
    const handleClick = useCallback(()=>{
        if (context) context.onHide();
        if (onHide) onHide();
    }, [
        context,
        onHide
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        ...rest,
        className: classNames(className, 'modal-header'),
        children: [
            children,
            closeButton && /*#__PURE__*/ _jsx(CloseButton, {
                title: closeLabel,
                onClick: handleClick
            })
        ]
    });
});
ModalHeader.displayName = 'ModalHeader';
